import type { SVGProps } from 'react';

const SvgPlayerVolumeMeter = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M10.24 4.05 6 9H4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h2l4.24 4.95c.6.71 1.76.28 1.76-.65V4.7c0-.93-1.16-1.36-1.76-.65M20 7h-5a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1m-2 6h-3a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1"
    />
  </svg>
);
export default SvgPlayerVolumeMeter;
